const createVirtualKeyboardMaxHeightSingleton = () => {
    let maxHeight = 0;
    let currentHeight = 0;

    return {
        getMaxHeight() {
            return maxHeight;
        },
        getCurrentHeight() {
            return currentHeight;
        },
        setInitialMaxHeight(height: number) {
            maxHeight = height;
        },
        setHeight(height: number) {
            currentHeight = height;
            if (height > maxHeight) {
                maxHeight = height;
            }
        },
        resetHeight() {
            currentHeight = 0;
            maxHeight = 0;
        },
    };
};

const virtualKeyboardHeightSingleton = createVirtualKeyboardMaxHeightSingleton();

export default virtualKeyboardHeightSingleton;
